<template>
  <div
    class="accruals-estimates-bulk-bar"
    role="toolbar"
    aria-label="Bulk estimate actions"
    data-testid="accruals-estimates-bulk-action-bar__bulk-selection-bar"
  >
    <div
      class="accruals-estimates-bulk-bar__inner"
      data-testid="accruals-estimates-bulk-action-bar__bulk-list"
    >
      <span
        class="accruals-estimates-bulk-bar__count"
        data-testid="accruals-estimates-bulk-action-bar__bulk-selection-count"
      >
        {{ selectedCount }} selected
      </span>
      <span class="accruals-estimates-bulk-bar__divider" aria-hidden="true" />
      <button
        type="button"
        class="accruals-estimates-bulk-bar__deselect"
        data-testid="accruals-estimates-bulk-action-bar__bulk-dismiss"
        @click="$emit('deselect-all')"
      >
        {{ deselectLabel }}
      </button>
      <span class="accruals-estimates-bulk-bar__divider" aria-hidden="true" />
      <button
        type="button"
        class="accruals-estimates-bulk-bar__action accruals-estimates-bulk-bar__action--reject"
        :disabled="loading"
        data-testid="accruals-estimates-bulk-action-bar__action--reject"
        @click="$emit('reject')"
      >
        {{ rejectLabel }}
      </button>
      <button
        type="button"
        class="accruals-estimates-bulk-bar__action accruals-estimates-bulk-bar__action--approve"
        :disabled="loading"
        data-testid="accruals-estimates-bulk-action-bar__action--approve-all"
        @click="$emit('approve-all')"
      >
        {{ approveLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { ACCRUALS_APPROVER_BULK_BAR } from '../accrualsEstimatesConstants';

export default {
  name: 'AccrualsEstimatesBulkBar',
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      deselectLabel: ACCRUALS_APPROVER_BULK_BAR.DESELECT_ALL,
      rejectLabel: ACCRUALS_APPROVER_BULK_BAR.REJECT_SELECTED,
      approveLabel: ACCRUALS_APPROVER_BULK_BAR.APPROVE_ALL,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimatesBulkBar.scss';
</style>
